// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"296":"fa07c07b","414":"fa07c07b","661":"fa07c07b"}[chunkId] + ".chunk.css";
};